import { z } from 'zod';
export const userAccessCodeStore = z.object({
    storeId: z.number(),
    hasCompletedOnboarding: z.boolean(),
    userEmails: z.array(z.string()),
});
//# sourceMappingURL=storeWithUsers.js.map